import React from "react";

const blogPosts = [
  {
    image: "/images/keyword/1.jpg",
    date: "19 May, 2026",
    author: "Om Sai Cab",
    comments: "5 Comments",
    title: "Mumbai to Goa Cab Service",
    link: "Mumbai-to-Goa-Cab",
    description:
      "Travel comfortably from Mumbai to Goa with our reliable cab service. Enjoy professional drivers, clean vehicles, affordable fares, and 24/7 customer support for a smooth journey.",
  },
  {
    image: "/images/keyword/24.jpg",
    date: "19 May, 2026",
    author: "Om Sai Cab",
    comments: "4 Comments",
    title: "Mumbai to Mahabaleshwar Cab",
    link: "/Mumbai-to-Mahabaleshwar-Cab",
    description:
      "Book a convenient Mumbai to Mahabaleshwar cab service with comfortable cars, experienced drivers, timely pickup, and budget-friendly pricing for a relaxing hill station trip.",
  },
];

const BlogStyleOne = () => {
  return (
    <section className="blog-style-one home-page-two">
      <div className="container">
        {/* Section Title */}
        <div className="block-title text-center">
          <div className="dot-line"></div>

          <p>Latest travel updates</p>

          <h2>Om Sai Cab Blogs</h2>
        </div>

        {/* Blog Row */}
        <div className="row">
          {blogPosts.map((post, index) => (
            <div
              className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
              key={index}
            >
              <div className="single-blog-style-one">
                {/* Image Block */}
                <div className="image-block">
                  <div className="inner-block">
                    <a href={post.link}>
                      <i className="fa fa-link"></i>
                    </a>

                    <img src={post.image} alt={post.title} />
                  </div>
                </div>

                {/* Text Block */}
                <div className="text-block">
                  <div className="meta-info">
                    <a href={post.link} className="date-block">
                      {post.date}
                    </a>

                    <a href={post.link}>by {post.author}</a>

                    <span className="sep">.</span>

                    <a href={post.link}>{post.comments}</a>
                  </div>

                  <h3>
                    <a href={post.link}>{post.title}</a>
                  </h3>

                  <p>{post.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogStyleOne;